export const compressImageFile = async (file) => {
    const reader = new FileReader();

    const result = new Promise((resolve, reject) => {
        reader.onload = async (e) => {
            const image = new Image();
            image.src = e.target.result;

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            // Дожидаемся загрузки изображения
            await new Promise((resolve) => {
                image.onload = () => resolve();
            });

            // Устанавливаем размеры канваса пропорционально размеру изображения
            const maxWidth = 800;
            const maxHeight = 600;
            let width = image.width;
            let height = image.height;

            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            canvas.width = width;
            canvas.height = height;

            ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

            const compressedImageBase64 = canvas.toDataURL('image/jpeg', 0.7);
            resolve(compressedImageBase64);
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    const compressedImageBase64 = await result;
    const blob = await (await fetch(compressedImageBase64)).blob();
    const fileName = file.name.replace(/\.\w+$/, '.jpg');
    const compressedFile = new File([blob], fileName, { type: 'image/jpeg' });

    return compressedFile;
};
